// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	CancelButton: 'cancel-button',
	SaveButton: 'save-button',
	PayFromTrustAccountCheckbox: 'pay-from-trust-account-checkbox',
	ShowAsUndertakingGivenCheckbox: 'show-as-undertaking-given-checkbox',
	FulfilledCheckbox: 'fulfilled-checkbox',
	ChangCheckbox: 'chang-checkbox',
	RequestToCloseAccountCheckbox: 'request-to-close-account-checkbox',
	RequestPaymentReceiptCheckbox: 'request-payment-receipt-checkbox',
	MentionRealEstateTransactionCheckbox:
		'mention-real-estate-transaction-checkbox',
	ApplyPerDiemCalculationsCheckbox: 'apply-per-diem-calculations-checkbox',
	Container: 'container',
	PayeeContainer: 'payee-container',
	ContactContainer: 'contact-container',
	Container1: 'container-1',
	OptionsContainer: 'options-container',
	NotesContainer: 'notes-container',
	StartDateDatePicker: 'start-date-date-picker',
	EndDateDatePicker: 'end-date-date-picker',
	FollowUpDateDatePicker: 'follow-up-date-date-picker',
	Name: 'name',
	ItemBeingPaid: 'item-being-paid',
	TitleOrDescription: 'title-or-description',
	CellPhone: 'cell-phone',
	Email: 'email',
	WorkPhone: 'work-phone',
	Fax: 'fax',
	AmountOfChequeEnclosed: 'amount-of-cheque-enclosed',
	PrincipalAmount: 'principal-amount',
	PerDiemInterest: 'per-diem-interest',
	AccountNumber: 'account-number',
	NotesTextArea: 'notes-text-area',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
